import { useCallback } from 'react';
import type { ComponentProps } from 'react';
import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import type { UtilityContext } from '@change-corgi/core/react/utilityContext';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { DownloadFlyerModalBody } from './components/DownloadFlyerModalBody';

async function LoadDownloadFlyerModalBody({
	errorReporter,
}: UtilityContext): Promise<typeof DownloadFlyerModalBody | (() => null)> {
	try {
		return (
			await import(
				/* webpackChunkName: "pages/starter-dashboard-multi-flyer-modal" */ './components/DownloadFlyerModalBody'
			)
		).DownloadFlyerModalBody;
	} catch (error) {
		const err =
			error instanceof Error ? error : new Error('Unknown error: Failed to load DownloadFlyerModalBody component');
		void errorReporter.report({ error: err, params: { event: 'LoadDownloadFlyerModalBody' } });
		return () => null;
	}
}

type Props = ComponentProps<typeof DownloadFlyerModalBody>;

export const DownloadFlyerModalBodyLoader: React.FC<Props> = (props) => {
	const utilityContext = useUtilityContext();
	const loadComponent = useCallback(async () => LoadDownloadFlyerModalBody(utilityContext), [utilityContext]);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Flex sx={{ alignItems: 'center', justifyContent: 'center', minHeight: 400 }}>
					<Spinner />
				</Flex>
			}
			{...props}
		/>
	);
};
